import { LuSmartphone } from 'react-icons/lu'

import Image from 'next/image'
import Link from 'next/link'

import { atmLogoWhite } from '@ui/assets'
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@ui/components/shadcn/ui'
import { Button } from '@ui/components/shadcn/ui/button'
import { BRANCH_DOWNLOAD_LINK } from '@ui/constants'

import { useDownloadAppAnalytics } from '@web-app/components/layout/SidebarAppLayout/analytics'
import { AppSidebar } from '@web-app/components/layout/SidebarAppLayout/app-sidebar'

export const SidebarAppLayout = ({
  userData,
  children,
}: {
  userData: {
    name: string
    email: string
  }
  children: React.ReactNode
}) => {
  const { trackTap } = useDownloadAppAnalytics()

  return (
    <SidebarProvider>
      <AppSidebar userData={userData} />
      <SidebarInset>
        {/* Mobile Header */}
        <header className="bg-primary group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear md:hidden">
          <div className="flex flex-1 items-center justify-between gap-2 px-4">
            <div className="flex items-center gap-2">
              <SidebarTrigger className="-ml-1 bg-white" />
              <Image
                src={atmLogoWhite}
                alt="ATM.com"
                className="h-auto w-1/5"
              />
            </div>
            <Button
              asChild
              size="sm"
              className="text-primary rounded-full bg-white font-semibold hover:bg-white/90"
            >
              <Link
                href={BRANCH_DOWNLOAD_LINK.dashboard}
                onClick={() => trackTap('mobileHeader')}
              >
                <LuSmartphone />
                Get the app
              </Link>
            </Button>
          </div>
        </header>
        {children}
      </SidebarInset>
    </SidebarProvider>
  )
}
